<template>
    <div>
        <div class="content-caption dashed">
            <span>清除信息</span>
        </div>
        <el-form :model="clearVoucher" ref="ruleForm">
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>清除单号</label>
                    </div>
                    <div class="form-value">
                        <el-tag v-if="clearVoucher.srcVoucherType != null" type="danger">{{ voucherTypeMap[clearVoucher.srcVoucherType] }}</el-tag>
                        <span>{{ clearVoucher.no }}</span>
                    </div>
                </div>
                <div class="form-group center" v-if="clearVoucher.srcVoucherType != null">
                    <div class="form-label">
                        <label>来源单据号：</label>
                    </div>
                    <div class="form-value">
                        <span>{{ clearVoucher.srcVoucherNo }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属业务单元</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{ clearVoucher.bizUnitName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>清除时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{ clearVoucher.theDate }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>仓库</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{ clearVoucher.warehouseName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>创建人</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{ clearVoucher.creatorName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>创建业务单元</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{ clearVoucher.creatorBizUnitName }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>创建时间</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{ clearVoucher.createTime }}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span><span class="color-laber"></span>{{ clearVoucher.assetType != 2 ? '资产信息' : '耗材信息' }}</span>
            </div>
            <div class="table-layout">
                <el-table :data="shopDeviceClearItems" border tooltip-effect="dark" style="width: 100%">
                    <!--由于样式问题贾鑫提议不固定列-->
                    <el-table-column align="left" prop="title" label="资产描述全称" width="170" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="name" label="名称" width="170" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="model" label="型号" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="fixedSpec" label="规格" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column label="资产基础信息" align="center">
                        <el-table-column align="left" prop="tmpNo" min-width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="innerNo" min-width="250" label="外部系统编号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="vendorUkno" min-width="250" label="商品标识码" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="catName" width="100" label="分类" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="groupName" label="分类分组" width="120" align="left" show-overflow-tooltip>
                            <template slot-scope="rows">
                                <span>{{ getGoodsCatDevcGroupName(rows.row.catId) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="brandName" width="150" label="品牌" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" width="50" label="图片">
                            <template slot-scope="rows">
                                <img :src="rows.row.imageUrl" v-if="rows.row.imageUrl != null && rows.row.imageUrl!=''">
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetKindName" label="财务类别" width="150" align="left" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column label="清除信息" align="center">
                        <el-table-column prop="clearCause" align="left" label="原因" width="60">
                            <template slot-scope="rows">
                                <span>{{ devcClearCauseMap[rows.row.clearCause] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="left" prop="departName" min-width="150" label="清除部门"></el-table-column>
                        <el-table-column align="right" prop="quantity" min-width="100" label="清除数量"></el-table-column>
                        <el-table-column align="left" prop="staffName" min-width="100" label="清除人员"></el-table-column>
                        <el-table-column align="left" prop="memo" label="备注" show-overflow-tooltip></el-table-column>
                    </el-table-column>
                    <el-table-column label="附加信息" align="center">
                        <el-table-column align="left" prop="batchNo" min-width="180" label="批次号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="left" prop="innerCode" min-width="180" label="资产编号" show-overflow-tooltip></el-table-column>
                        <!--<el-table-column align="left" prop="" min-width="100" label="分组" show-overflow-tooltip></el-table-column>-->
                        <el-table-column align="center" prop="theUnit" min-width="50" label="单位"></el-table-column>
                    </el-table-column>

                    <el-table-column label="资产价值" align="center">
                        <el-table-column align="center" min-width="100" label="入账方式">
                            <template slot-scope="rows">
                                <span>{{ acctEnterWayMap[rows.row.acctEnterWay] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100" label="是否财务在账">
                            <template slot-scope="rows">
                                <span>{{ rows.row.fiscalAcctFlag == 1 ? '是' : '否' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="orgWorth" min-width="80" label="原值(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.orgWorth != null">{{ rows.row.orgWorth.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="netWorth" min-width="80" label="净值(元)">
                            <template slot-scope="rows">
                                <span v-if="rows.row.netWorth != null">{{ rows.row.netWorth.toFixed(2) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="right" prop="assetType" min-width="80" label="管理方式">
                            <template slot-scope="rows">
                                <span>{{ rows.row.assetType == 0 ? '单品式管理' : '批量式管理' }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-layout">
                <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            </div>
        </el-form>
    </div>
</template>
<script>
import { Utils } from '../../app.base'
import { MsgBox } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { getDevcGroupNameByCatId } from '../index'
//
import assetVchrApi from '../../api/assetVchr'
//
let mockConfigData = {
    'queryFields': [],
    'sortFields': []
};
//
export default {
    name: 'swb-shop-device-clear-voucher',
    avlActions: '',
    avlScopes: 'vendor',
    notAsResc: true,
    authen: false,
    desc: '清除单查看',
    props: ['id'],
    data: function () {
        return {
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            pageNumber: 1,
            bizLogList: [],
            //
            queryConfig: mockConfigData,
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            //
            clearVoucher: {},
            shopDeviceClearItems: [],
            //
            voucherTypeMap: {},
            devcClearCauseMap: {},
            acctEnterWayMap: {},
        }
    },
    created: function () {
        this.pageSize = this.pageSizes.first();
        //
        this.devcClearCauseMap = getEnumMap('devcClearCause', 'value2text');
        this.acctEnterWayMap = getEnumMap('acctEnterWay', 'value2text');
        this.voucherTypeMap = getEnumMap('devcVoucherType', 'value2text');
        //
        this.getclearVoucherById();
    },
    methods: {
        getGoodsCatDevcGroupName: function (catId) {
            return getDevcGroupNameByCatId(catId);
        },
        getclearVoucherById: function () {
            let self = this;
            let postData = {};
            postData.id = self.id;
            let loading = MsgBox.loading();
            assetVchrApi.getShopDeviceClearVoucher(postData, function (result) {
                loading.close();
                if(result.type == 'info') {
                    self.clearVoucher = result.data || {};
                    //
                    self.getShopDeviceClearItemList()
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.getShopDeviceClearItemList();
        },
        // 获取 领用单项分页列表
        getShopDeviceClearItemList: function () {
            let self = this;
            //
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber,
            };
            //
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            filterItems.voucherId = self.id;
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            let theLoad = MsgBox.loading();
            assetVchrApi.getShopDeviceClearItemList(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let shopDeviceClearItems = result.data.rows;
                    // 耐用品-处理展示数据
                    if(!Utils.isNoB(shopDeviceClearItems) && shopDeviceClearItems.length > 0) {
                        let length = shopDeviceClearItems.length;
                        for(let i = 0; i < length; i++) {
                            let item = shopDeviceClearItems[i];
                            if(item.durable) {
                                item.clearAvQuantity = item.quantity - item.quantity2;
                            }
                        }
                    }
                    //
                    self.shopDeviceClearItems = shopDeviceClearItems;
                    self.totalCount = result.data.pagination.totalCount;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/compo/clearVoucher/ShopDeviceClearVoucherShow.vue